<div class="header-wrapper">
    <div class="container">
        <div id="header" class="row py-2 align-items-center">

            <!-- Logo -->
            <div class="col-6 col-md-3 d-flex align-items-center">
                <button class="hamburger-menu d-md-none mr-3" (click)="toggleMobileMenu()" aria-label="Menú">
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
                <a [routerLink]="['/ciudadano']" class="logo-link">
                    <img src="assets/images/logo-boca.png" height="48px" alt="Boca Digital">
                </a>
            </div>

            <!-- Menú central (desktop) -->
            <div class="col-md-6 d-none d-md-flex justify-content-center align-items-center">
                <nav class="main-nav">
                    <a routerLink="/ciudadano/tramites" routerLinkActive="nav-active" class="nav-link-item">
                        Trámites
                    </a>
                    <a routerLink="/reportes-atendidos" routerLinkActive="nav-active" class="nav-link-item">
                        Reportes
                    </a>
                </nav>
            </div>

            <!-- Derecha: usuario o botón acceso -->
            <div class="col-6 col-md-3 d-flex justify-content-end align-items-center">

                <!-- Usuario logueado -->
                <ul *ngIf="currentUser" class="d-none d-md-flex align-items-center nav-menus mb-0 pl-0">
                    <li (click)="toggleDropdown()" class="user-menu-item">
                        <div class="d-flex align-items-center user-pill">
                            <span class="user-initials">{{ currentUser.initials }}</span>
                            <span class="user-display-name ml-2">{{ currentUser.displayName }}</span>
                            <i class="fa fa-chevron-down ml-2 chevron-icon"></i>
                        </div>
                        <ul *ngIf="isOpen" class="profile-dropdown bg-white">
                            <li>
                                <a *ngIf="currentUser?.roles !== 'admin'"
                                   [routerLink]="['/ciudadano/profile/', currentUser?.id]"
                                   class="dropdown-item-link">
                                    <i class="fa fa-user-circle mr-2"></i> Ver perfil
                                </a>
                            </li>
                            <li class="dropdown-divider-line"></li>
                            <li (click)="logout()" class="dropdown-item-link logout-link">
                                <i class="fa fa-sign-out mr-2"></i> Cerrar sesión
                            </li>
                        </ul>
                    </li>
                </ul>

                <!-- Sin sesión: botón acceso ciudadano -->
                <a *ngIf="!currentUser" routerLink="/ciudadano/iniciar-sesion" class="btn-acceso d-none d-md-inline-flex">
                    <i class="fa fa-user mr-2"></i> Acceso ciudadano
                </a>

                <!-- Icono usuario en móvil (si logueado) -->
                <a *ngIf="currentUser" [routerLink]="['/ciudadano/profile/', currentUser?.id]"
                   class="d-md-none mobile-user-icon">
                    <span class="user-initials user-initials-sm">{{ currentUser.initials }}</span>
                </a>
            </div>

        </div>
    </div>
</div>

<!-- Overlay móvil -->
<div class="mobile-menu-overlay" [class.active]="isMobileMenuOpen" (click)="closeMobileMenu()"></div>

<!-- Menú móvil -->
<div class="mobile-menu" [class.active]="isMobileMenuOpen">
    <div class="mobile-menu-header">
        <img src="assets/images/logo-boca.png" height="38px" alt="Boca Digital">
        <button class="mobile-close-btn" (click)="closeMobileMenu()">
            <i class="fa fa-times"></i>
        </button>
    </div>
    <div class="mobile-menu-content">
        <ul class="mobile-nav-list">
            <li>
                <a routerLink="/ciudadano/tramites" routerLinkActive="mobile-nav-active"
                   (click)="closeMobileMenu()">
                    <i class="fa fa-list-alt mr-3"></i> Trámites
                </a>
            </li>
            <li>
                <a routerLink="/reportes-atendidos" routerLinkActive="mobile-nav-active"
                   (click)="closeMobileMenu()">
                    <i class="fa fa-flag mr-3"></i> Reportes
                </a>
            </li>
        </ul>

        <div class="mobile-menu-footer">
            <!-- Logueado -->
            <ng-container *ngIf="currentUser">
                <div class="mobile-user-info">
                    <div class="user-initials user-initials-lg">{{ currentUser.initials }}</div>
                    <span class="mobile-user-name">{{ currentUser.displayName }}</span>
                </div>
                <a *ngIf="currentUser?.roles !== 'admin'"
                   [routerLink]="['/ciudadano/profile/', currentUser?.id]"
                   (click)="closeMobileMenu()" class="mobile-btn mobile-btn-outline">
                    Ver perfil
                </a>
                <a (click)="logout(); closeMobileMenu()" class="mobile-btn mobile-btn-danger">
                    Cerrar sesión
                </a>
            </ng-container>
            <!-- Sin sesión -->
            <ng-container *ngIf="!currentUser">
                <a routerLink="/ciudadano/iniciar-sesion" (click)="closeMobileMenu()"
                   class="mobile-btn mobile-btn-primary">
                    <i class="fa fa-user mr-2"></i> Acceso ciudadano
                </a>
            </ng-container>
        </div>
    </div>
</div>
